import { render, staticRenderFns } from "./ModalCadastrarCategoriaEnquete.vue?vue&type=template&id=6d367d34"
import script from "./ModalCadastrarCategoriaEnquete.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarCategoriaEnquete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports